import React from 'react';
import { DashboardStickyFooter } from '@components/layout/Sidebar/dashboad-sticky-footer';
import {
  useSubscriptions,
  useSubscriptionsDispatch,
} from '@features/subscriptions/context/subscription-context';
import { Button, FlexView } from '@goodfynd/ui';
import { addClassNames } from '@goodfynd/theme';
import { Text } from '@goodfynd/ui';
import { renderPrice } from '@utils/number-util';

import { pluralize } from '../../../../utils/string-util';
import { SubscriptionsCheckoutDrawer } from '../subscriptions-checkout';

import type { SubscriptionCartFooterProps } from './types';

import classes from './SubscriptionCartFooter.module.css';

export const SubscriptionCartFooter = ({
  className,
}: SubscriptionCartFooterProps) => {
  const { cartSubtotal, hasUpdates, totalItems } = useSubscriptions();
  const { clearCart } = useSubscriptionsDispatch();

  return (
    <DashboardStickyFooter hidden={!hasUpdates}>
      <div className={addClassNames(classes.container, className)}>
        <div>
          <Text as="subhead2">
            {totalItems} {pluralize('item', totalItems)} in cart
          </Text>
          <Text>{renderPrice(cartSubtotal)} subtotal</Text>
        </div>

        <FlexView align="center" justify="center">
          <Button
            className={classes['button-mobile']}
            color="danger"
            content="Clear"
            onClick={clearCart}
            rank="tertiary"
            size="small"
          />

          <div className={classes['button-container']}>
            <SubscriptionsCheckoutDrawer targetProps={{ fullWidth: true }} />
          </div>
        </FlexView>
      </div>
    </DashboardStickyFooter>
  );
};
